import { Http, Headers } from '@angular/http';

export class ApiAwards {
  static get parameters() {
    return [[Http]];
  }

  // serverData = 'http://localhost:5051/';
  serverData = 'https://be.exquisite-awards.com:5053/';
  // serverData = 'http://13.250.110.183:5050/';
  keyAwards = '!23456&*()+_)(*&^#EFB$%^&*)OIJNcvhjEF';

  constructor(private http: Http) { }

  submitData(response_token, full_name, email, phone, country, data_submit) {
    const url = this.serverData + 'api/submit_votes_otp';
    const headers = new Headers();
    headers.append('Token', this.keyAwards);
    headers.append('Content-Type', 'application/x-www-form-urlencoded');

    const body = new URLSearchParams();
    body.set('response', response_token);
    body.set('full_name', full_name);
    body.set('email', email);
    body.set('phone', phone);
    body.set('country', country);
    body.set('data_submit', JSON.stringify(data_submit));

    const data = body.toString();

    // get response
    const response = this.http.post(url, data, { headers: headers });

    return response;

  }

  checkOTP(response_token, full_name, email, phone, country, otp, data_submit) {
    const url = this.serverData + 'api/checkotp';
    const headers = new Headers();
    headers.append('Token', this.keyAwards);
    headers.append('Content-Type', 'application/x-www-form-urlencoded');

    const body = new URLSearchParams();
    body.set('response', response_token);
    body.set('full_name', full_name);
    body.set('email', email);
    body.set('phone', phone);
    body.set('country', country);
    body.set('otp', otp);
    body.set('data_submit', JSON.stringify(data_submit));

    const data = body.toString();

    // get response
    const response = this.http.post(url, data, { headers: headers });

    return response;

  }

  otp(response_token, full_name, email, phone, country) {
    const url = this.serverData + 'api/otp';
    const headers = new Headers();
    headers.append('Token', this.keyAwards);
    headers.append('Content-Type', 'application/x-www-form-urlencoded');

    const body = new URLSearchParams();
    body.set('response', response_token);
    body.set('full_name', full_name);
    body.set('email', email);
    body.set('phone', phone);
    body.set('country', country);

    const data = body.toString();

    // get response
    const response = this.http.post(url, data, { headers: headers });

    return response;

  }

  // captchaRes(token){
  //   const url = this.serverData + 'api/verify_captcha';
  //   const headers = new Headers();
  //   headers.append('Token', this.keyAwards);
  //   headers.append('Content-Type', 'application/x-www-form-urlencoded');

  //   const body = new URLSearchParams();
  //   body.set('response', token);

  //   const data = body.toString();

  //   // get response
  //   const response = this.http.post(url, data, { headers: headers });

  //   return response;
  // }

  getGeneral() {
    const url = this.serverData + 'api/get_general';
    const headers = new Headers();
    headers.append('Token', this.keyAwards);
    headers.append('Content-Type', 'application/x-www-form-urlencoded');

    const response = this.http.get(url, { headers: headers });
    return response;
  }

  getCounters() {
    const url = this.serverData + 'api/get_counters';
    const headers = new Headers();
    headers.append('Token', this.keyAwards);
    headers.append('Content-Type', 'application/x-www-form-urlencoded');

    const response = this.http.get(url, { headers: headers });
    return response;
  }

  getSponsors(){
    const url = this.serverData + 'api/get_sponsors';
    
    const headers = new Headers();
    headers.append('Token', this.keyAwards);
    headers.append('Content-Type', 'application/x-www-form-urlencoded');

    const response = this.http.get(url, { headers: headers });
    return response;
  }

  getCategories(){
    const url = this.serverData + 'api/get_categories';
    
    const headers = new Headers();
    headers.append('Token', this.keyAwards);
    headers.append('Content-Type', 'application/x-www-form-urlencoded');

    const response = this.http.get(url, { headers: headers });
    return response;
  }

  getCategory(id: string) {
    const url = this.serverData + 'api/get_category?_id=' + id;

    const headers = new Headers();
    headers.append('Token', this.keyAwards);
    headers.append('Content-Type', 'application/x-www-form-urlencoded');

    const response = this.http.get(url, { headers: headers });
    return response;
  }

  getCategoryPos(pos: number) {
    const url = this.serverData + 'api/get_category_pos?pos=' + pos;

    const headers = new Headers();
    headers.append('Token', this.keyAwards);
    headers.append('Content-Type', 'application/x-www-form-urlencoded');

    const response = this.http.get(url, { headers: headers });
    return response;
  }

  getList(id:string) {
    const url = this.serverData + 'api/get_list?_id='+id;

    const headers = new Headers();
    headers.append('Token', this.keyAwards);
    headers.append('Content-Type', 'application/x-www-form-urlencoded');

    const response = this.http.get(url, { headers: headers });
    return response;
  }

  getAds(id:string) {
    const url = this.serverData + 'api/get_ads?_id='+id;

    const headers = new Headers();
    headers.append('Token', this.keyAwards);
    headers.append('Content-Type', 'application/x-www-form-urlencoded');

    const response = this.http.get(url, { headers: headers });
    return response;
  }

  getFLists() {
    const url = this.serverData + 'api/get_f_lists';
    const headers = new Headers();
    headers.append('Content-Type', 'application/x-www-form-urlencoded');

    const response = this.http.get(url, { headers: headers });
    return response;
  }

  getFVoters() {
    const url = this.serverData + 'api/get_f_voters';
    const headers = new Headers();
    headers.append('Content-Type', 'application/x-www-form-urlencoded');

    const response = this.http.get(url, { headers: headers });
    return response;
  }

  getVoters() {
    const url = this.serverData + 'api/live_voter';
    const headers = new Headers();
    headers.append('Content-Type', 'application/x-www-form-urlencoded');

    const response = this.http.get(url, { headers: headers });
    return response;
  }

  getTotalVoters() {
    const url = this.serverData + 'api/total_voter';
    const headers = new Headers();
    headers.append('Content-Type', 'application/x-www-form-urlencoded');

    const response = this.http.get(url, { headers: headers });
    return response;
  }

}
